import React from 'react';
import PropTypes from 'prop-types';
import { FaStar } from 'react-icons/fa';
import tw from 'twin.macro';
import { styled } from '@mui/material/styles';
import currencySymbol from '../../../helpers/currencySymbol';
import getTourRateToDisplay from '../../../helpers/getTourRateToDisplay.ts';

const TooltipContainer = styled('div')`
  ${tw`absolute bg-white rounded-lg shadow-lg w-64 text-left z-30 mt-8`}
`;
const TourName = styled('h3')`
  ${tw`font-bold text-base text-gray-800`}
`;
const Star = styled(FaStar)`
  ${tw`mr-1`}
`;

// Same shape as the hotel tooltip — picture, name, rating, price — but a tour has no nightly rate and no
// display preference to honour: one indicative price, and the exact one arrives with availability.
const TourMapTooltip = ({ marker }) => {
  const currencyCode = marker.currencyCode || 'USD';
  const filledStars = marker.rating ? Math.round(Number(marker.rating)) : 0;

  return (
    <TooltipContainer>
      {marker.image && (
        <img
          src={marker.image}
          alt={marker.name}
          className="w-full h-32 object-cover rounded-t-lg"
        />
      )}
      <div className="p-2">
        <TourName>{marker.name}</TourName>
        {!!marker.rating && (
          <div className="flex items-center text-xs text-gray-600 my-1">
            {Array.from({ length: 5 }).map((_, index) => (
              <Star
                key={`${index.toString()}`}
                color={index < filledStars ? '#FFC107' : '#E0E0E0'}
              />
            ))}
            {marker.reviewCount > 0 && <span className="ml-1">({marker.reviewCount})</span>}
          </div>
        )}
        {!!marker.durationText && (
          <div className="text-xs font-normal text-gray-600">{marker.durationText}</div>
        )}
        <div className="text-base font-bold text-gray-900 mt-1 mb-1">
          From {currencySymbol(currencyCode)}
          {getTourRateToDisplay(marker)}
        </div>
      </div>
    </TooltipContainer>
  );
};

TourMapTooltip.propTypes = {
  marker: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    rating: PropTypes.number,
    reviewCount: PropTypes.number,
    durationText: PropTypes.string,
    cost: PropTypes.number,
    currencyCode: PropTypes.string,
  }).isRequired,
  // google-map-react positions a child by these, so they are passed even though nothing here reads them.
  lat: PropTypes.number,
  lng: PropTypes.number,
};

TourMapTooltip.defaultProps = {
  lat: undefined,
  lng: undefined,
};

export default TourMapTooltip;
